/* eslint-disable @typescript-eslint/naming-convention */

import { UpdateEmailMutation, UpdateEmailMutationVariables } from '@generated/UpdateEmailMutation';
import { UPDATE_EMAIL_MUTATION } from '@graphql/mutations/UpdateEmailMutation';
import { useGraphMutationWithFeedback } from '@hooks/useMutation';
import { useParams } from 'react-router-dom';

import { UpdateEmailParams, UseUpdateEmail } from '.';

/**
 * Hook to initiate the update email flow
 * @returns an object holding a function responsible for updating the email
 */
export function useUpdateEmail(): UseUpdateEmail {
  const { userId: ID } = useParams();

  const [mutate, { loading }] = useGraphMutationWithFeedback<
    UpdateEmailMutation,
    UpdateEmailMutationVariables
  >(UPDATE_EMAIL_MUTATION, { type: 'form' });

  const updateEmail = async (values: UpdateEmailParams) => {
    const { error } = await mutate({
      variables: {
        input: {
          ID,
          newEmail: values.email,
        },
      },
    });

    return error || null;
  };

  return { updateEmail, loading };
}
